// extracted by mini-css-extract-plugin
export default {"main_container":"global_main_container__UNh4i","button_container":"global_button_container__FJivj"};